export default {
    meta: {
        title: '鱼你在一起-沟通列表',
        url: '/fishtogether/tasklist',
        urlName: '鱼你拓店任务'
    }
};
